import NewCreditCard from './NewCreditCard'

export default NewCreditCard
